import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  chartBackground: {
    padding: `${theme.spacing(10)}px ${theme.spacing(2)}px ${theme.spacing(3)}px 0`,
    width: '100%'
  },
  chart: {
    padding: '0px !important',
    position: 'relative'
  },
  emptyGraph: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '6px',
    backgroundColor: '#FFFFFF',
    padding: theme.spacing(8, 30),
    paddingTop: theme.spacing(3)
  },
  chartLegend: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: theme.spacing(3),
    paddingLeft: theme.spacing(5)
  },
  amount: {
    fontSize: 13,
    fontWeight: 'normal'
  },
  rateLegend: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  rateLegendLabel: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: theme.spacing(2)
  },
  behind: {
    display: 'block',
    width: 16,
    height: 16,
    borderRadius: '50%',
    backgroundColor: '#FFD000',
    marginRight: theme.spacing(1)
  },
  onTrack: {
    display: 'block',
    width: 16,
    height: 16,
    borderRadius: '50%',
    backgroundColor: '#05C34B',
    marginRight: theme.spacing(1)
  },
  ahead: {
    display: 'block',
    width: 16,
    height: 16,
    borderRadius: '50%',
    backgroundColor: '#B1FFDA',
    marginRight: theme.spacing(1)
  },
  icon: {
    marginBottom: '4px'
  },
  header: {
    color: '#8688A1',
    marginBottom: '4px'
  },
  text: {
    fontSize: '14px',
    letterSpacing: 0,
    lineHeight: '21px',
    color: '#8688A1',
    fontWeight: 'normal',
    textAlign: 'center'
  },
  topHeader: {
    color: '#00000',
    marginBottom: '24px',
    fontWeight: 500
  },
  milestoneLegend: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  milestoneLabel: {
    color: '#8688A1'
  },
  milestoneValue: {
    color: '#00000',
    fontWeight: 'normal',
    fontSize: 13,
    marginLeft: 4
  }
}))
